export enum ErrorCodesWithTrackingValues {
    ProductBlocked = 'productblocked',
    ServerError = 'servererror',
    ProviderNotFound = 'providernotfound',
}
